/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_UnscheduledInputs */

const en_orders_unscheduled = /** @type {(inputs: Orders_UnscheduledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unscheduled`)
};

const es_orders_unscheduled = /** @type {(inputs: Orders_UnscheduledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin programar`)
};

/**
* | output |
* | --- |
* | "Unscheduled" |
*
* @param {Orders_UnscheduledInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_unscheduled = /** @type {((inputs?: Orders_UnscheduledInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_UnscheduledInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_unscheduled(inputs)
	return es_orders_unscheduled(inputs)
});